/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2018-08-12 15:01:51
 */
import {
  service
} from '@/utils/request'

export default {
  //分页获取医院列表
  getHospitalList: (data) => {
    return service({
      url: '/cloud/uac/hospital/pages',
      method: 'post',
      data
    })
  },
  //新增医院
  updateHospital(data) {
    return service({
      url: '/cloud/uac/hospital/save',
      method: 'post',
      data: data
    })
  },
  //删除医院
  deleteHospital(path){
    return service({
        url: '/cloud/uac/hospital/delete' + path,
        method: 'get'
      })
  },
  //获取市场组
  marketGroups(){
    return service({
        url: '/cloud/uac/hospital/marketGroups',
        method: 'get'
      })
  },
  //获取bd
  getBds(){
    return service({
        url: '/cloud/uac/hospital/bds',
        method: 'get'
      })
  },
  //批量换BD
  batchChangeBd(params){
    return service({
        url: '/cloud/uac/hospital/batchChangeBd',
        method: 'post',
        params
      })
  },
  //批量分配BD
  batchAllotBd(params){
    return service({
        url: '/cloud/uac/hospital/batchAllotBd',
        method: 'post',
        params
      })
  },
  //分配bd-单个医院
  allotBd(params){
    return service({
        url: '/cloud/uac/hospital/allotBd',
        method: 'post',
        params
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/systemManage/hospitalManage.js